import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from "./Components/Login"; 
import { ForgotPassword } from "./Components/ForgotPassword";
import { VerifyOtp } from "./Components/VerifyOtp";
import { ResetPassword } from "./Components/ResetPassword";
import { Layout } from "./Pages/Layout"; 
import { PublicRoute } from "./Components/PublicRoute";
import { ProtectedRoute } from "./Components/ProtectedRoute";
import { ToastContainer } from "react-toastify";
import useFirebaseMessaging from "./hooks/useFirebaseMessaging";
import 'react-toastify/dist/ReactToastify.css';

function App() {
  useFirebaseMessaging();
  return (
    <>
      <ToastContainer />
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
        <Route path="/verify-otp" element={<PublicRoute><VerifyOtp /></PublicRoute>} />
        <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />
        
        <Route 
          path="/*" 
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          } 
        />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
}

export default App;